import { useEffect, useState } from "react";

const getTimeformat = (time: number) => {
    if(time < 10) {
        return "0" + String(time);
    } else {
        return String(time);
    }
}

export function Timer ({leftSeconds}:{leftSeconds: number}) {
    const [time, setTime] = useState(leftSeconds); // 남은 시간 (단위: 초)

    useEffect(() => {
        const timer = setInterval(() => {
            setTime((prev) => prev - 1);
        }, 1000);
        
        if (time === 0) { 
            clearInterval(timer);
        }
        return () => clearInterval(timer);
    }, [time]);
    return (
        <div>
            <span>{getTimeformat(Math.floor(time / 60))}</span>
            <span> : </span>
            <span>{getTimeformat(time % 60)}</span>
        </div>
    );
}